function About() {
  return (
    <div className="about">
      <div className="about__image" />
      <div className="about__content">
        <h2 className="about__title">About the author</h2>
        <p className="about__text">My name is Ilan Brofman and i'm a Full Stack Web Developer.</p>
        <p className="about__text">
          This Project was built as a Final Project for the Practicum100 Web Development Course By Yandex, with the following technologies:
          ReactJS, NodeJS, Javascript, and CSS.
        </p>
        <p className="about__text">
          I'm very excited to start a new path as a web developer! I hope you enjoyed browsing my website 😁

        </p>
      </div>
    </div>
  );
}

export default About;
